import { render, staticRenderFns } from "./JobDetailsCard.vue?vue&type=template&id=051ee3f3&"
import script from "./JobDetailsCard.vue?vue&type=script&lang=js&"
export * from "./JobDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports